import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { fadeUp, Section } from "./shared";

const FAQS = [
  { q: "Will applying affect my credit score?", a: "No. We run a soft search only, which checks your eligibility without leaving a mark on your credit file." },
  { q: "Will I have to pay anything to use the service?", a: "No. Our service is free to you — we're paid by the lender when your funding completes." },
  { q: "How long does it actually take to get funded?", a: "From a completed application, funds can land in as little as 6 hours, depending on the lender and your business profile." },
  { q: "Who sees my information?", a: "Only our team and the single best-match lender we pair you with. We never sell your data or make multiple applications." },
  { q: "What if I've already been declined elsewhere?", a: "That's fine — many of our funded clients were turned down by their bank first. We match you to lenders more likely to approve your profile." },
  { q: "Who are the lenders you work with?", a: "Over 100 FCA-regulated UK lenders including iwoca, Funding Circle, Bizcap and more compete for your application." },
];

export const FAQSection = () => (
  <Section id="faq" className="pb-24 sm:pb-32">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <motion.h2 variants={fadeUp} className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight mb-12 text-center">
        Frequently asked
      </motion.h2>
      <motion.div variants={fadeUp} custom={1}>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-[#052F24]/12" data-testid={`faq-${i}`}>
              <AccordionTrigger className="text-left font-display font-bold text-xl sm:text-2xl tracking-tight hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#052F24]/65 font-light text-base pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </Section>
);
